import React from 'react';

const Component: React.FC = () => (
  <svg version='1.1' viewBox='0 0 512 512'>
    <g>
      <path
        d='M0,218.241l20.913,15.158l118.904,86.199v132.866l103.404-57.892l92.52,67.064L512,50.363L0,218.241z
		 M57.326,227.202L442.817,100.81L156.609,299.193L57.326,227.202z M166.202,407.459v-68.74l53.494,38.786L166.202,407.459z
		 M324.494,420.906L172.776,310.92L455.69,114.808L324.494,420.906z'
      />
    </g>
  </svg>
);

export default Component;
